import React from 'react'
import t from 'prop-types'
import { css } from 'linaria'
import cx from 'classnames'
import Image from '../../Images/Image'
import LabelList from '../../Labels/LabelList'
import Avatar from '../../Avatar'
import StatSmall from '../../Infographics/StatSmall'
import { Link } from 'gatsby'

const cardImage = css`
  mix-blend-mode: multiply;
`

const headingWrap = css`
  .heading--hover {
    background-image: linear-gradient(180deg, transparent 70%, #8bd0ff 0);
    background-size: 0 100%;
  }
  &:hover {
    .heading--hover {
      background-size: 100% 100%;
    }
  }
  .isOnDarkBg .heading--hover {
    background-image: linear-gradient(180deg, transparent 70%, #007acc 0);
  }
`

const imageLink = css`
  &:hover {
    .${cardImage} {
      filter: grayscale(100%);
    }
  }
`

const Card = ({
  author,
  heading,
  image,
  isOnDarkBg,
  logo,
  labels,
  link,
  stat,
  subheading,
}) => {
  return (
    <article>
      {image && (
        <Link
          className={`${imageLink} group relative block overflow-hidden bg-blue-transparent hover:bg-blue-200 focus:bg-blue-200 transition-colors ease duration-500`}
          to={link.url}
        >
          {logo && (
            <div className="absolute top-0 left-0 z-10 flex items-center justify-center w-full h-full bg-gray-700 bg-opacity-60 transition-image ease-linear duration-500">
              <Image className="h-10 lg:h-16 w-auto" src={logo.src}></Image>
            </div>
          )}
          <Image
            className={`${cardImage} z-0 block w-full h-auto transition-image ease-linear duration-500`}
            {...image}
          />
        </Link>
      )}
      {labels && (
        <div className={`${image ? 'mt-8' : 'mt-0'}`}>
          <LabelList
            isOnDarkBg={isOnDarkBg ? isOnDarkBg : false}
            labels={labels}
          />
        </div>
      )}
      <div className={`${headingWrap} group cursor-pointer`}>
        {heading && (
          <h3
            className={cx(
              'mt-3 text-2xl md:text-3xl lg:text-4xl leading-tight font-serif font-bold',
              {
                'text-gray-700': !isOnDarkBg,
                'text-white isOnDarkBg': isOnDarkBg,
              }
            )}
          >
            <Link to={link.url}>
              <span className="heading--hover bg-no-repeat transition-bg-size ease-in-out duration-500">
                {heading}
              </span>
            </Link>
          </h3>
        )}
        {subheading && (
          <Link to={link.url}>
            <div
              className={cx(
                'mt-3 text-base lg:text-lg leading-normal font-sans font-normal',
                {
                  'text-gray-600': !isOnDarkBg,
                  'text-white': isOnDarkBg,
                }
              )}
              dangerouslySetInnerHTML={{ __html: subheading }}
            ></div>
          </Link>
        )}
      </div>
      {author && (
        <div className="mt-6">
          <Avatar {...author} isSmall></Avatar>
        </div>
      )}
      {stat && (
        <div class="mt-4 pt-4 border-t border-gray-400">
          <StatSmall isOnDarkBg={isOnDarkBg} {...stat}></StatSmall>
        </div>
      )}
    </article>
  )
}

Card.propTypes = {
  author: t.object,
  heading: t.string,
  image: t.object,
  isOnDarkBg: t.bool,
  logo: t.object,
  labels: t.object,
  link: t.object,
  stat: t.object,
  subheading: t.string,
}

Card.defaultProps = {
  isOnDarkBg: false,
}

export default Card
